import { futureActionAcceptableResults, nameMapEnglish, detectionCategory, detectionType, ConfigType, ConfigSex, categoryType, operationLog, packageProductTypes, terrace, contractStatus, dayType, gender, orderStatusResults, holidayType, collectorType, systemDetermine, dataAnalysisedSystemDetermine } from 'json/lab-order'
export function formatActionAcceptableResult (value) {
  for (let item of futureActionAcceptableResults) {
    if (item.key === value) {
      return item.value
    }
  }
  if (value) {
    console.error('[formatActionAcceptableResult]方法未找到对应的item', value)
  }
  return ''
}
export function formatDetectionCategory (key) {
  for (let item of detectionCategory) {
    if (item.key === key) {
      return item.value
    }
  }
  return ''
}
export function getDeliveryType (key) {
  for (let item of terrace) {
    if (item.value === key) {
      return item.label
    }
  }
  return ''
}
export function getdayType (key) {
  for (let item of dayType) {
    if (item.key === key) {
      return item.value
    }
  }
  return ''
}
export function getgender (key) {
  for (let item of gender) {
    if (item.key === key) {
      return item.value
    }
  }
  return ''
}
export function getnameMapEnglish (key) {
  for (let item of nameMapEnglish) {
    if (item.key === key) {
      return item.value
    }
  }
  return ''
}
export function getcontractStatus (key) {
  for (let item of contractStatus) {
    if (item.key === key) {
      return item.value
    }
  }
  return ''
}
export function formatConfigSex (key) {
  for (let item of ConfigSex) {
    if (item.key === key) {
      return item.value
    }
  }
  return ''
}
export function formatdetection (value) {
  for (let item of detectionType) {
    if (item.value === value) {
      return item.key
    }
  }
  return ''
}
export function formatConfigType (key) {
  for (let item of ConfigType) {
    if (item.key === key) {
      return item.value
    }
  }
  return ''
}
export function formatCategoryToType (key) {
  for (let item of categoryType) {
    if (item.key === key) {
      return item.value
    }
  }
  return ''
}
export function formatOperationLog (value) {
  for (let item of operationLog) {
    if (item.key === value) {
      return item.value
    }
  }
  return ''
}
export function compare (prop) {
  return function (obj1, obj2) {
    var val1 = obj1[prop]
    var val2 = obj2[prop]; if (val1 < val2) {
      return -1
    } else if (val1 > val2) {
      return 1
    } else {
      return 0
    }
  }
}
export function formatPackageProductType (key) {
  for (let item of packageProductTypes) {
    if (item.key === key) {
      return item.value
    }
  }
  return ''
}
export function cycleChange (val) {
  if (!val) {
    return ''
  }
  return val.slice(1, -1)
}
export function timeChange (val) {
  var date = new Date(val)
  return date.getTime()
}
/**
 * 格式化批次状态结果
 * @param {*} key
 */
export function formResult (key) {
  for (let item of orderStatusResults) {
    if (item.key === key) {
      return item.value
    }
  }
  return ''
}
export function formatHolidayType (value) {
  for (let item of holidayType) {
    if (item.value === value) {
      return item.label
    }
  }
  return ''
}
/**
 * 格式化采集器样本类型
 * @param {*} value
 */
export function formatCollectorType (value) {
  for (let item of collectorType) {
    if (item.key === value) {
      return item.value
    }
  }
  return ''
}
// 格式化系统判定结果
export function formatSystemDetermine (value) {
  for (let item of systemDetermine) {
    if (item.key === value) {
      return item.value
    }
  }
  return ''
}
// 格式化数据质控系统判定结果
export function formatDataSystemDetermine (value) {
  for (let item of dataAnalysisedSystemDetermine) {
    if (item.key === value) {
      return item.value
    }
  }
  return ''
}
